import React from 'react';
import reactCSS, { handleHover } from 'reactcss';

import { Swatch } from '../common';

export var CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = reactCSS({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: color, 
        transition: '100ms box-shadow ease',
        opacity: '100%'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.1)',
        opacity: '100%'
      }
    },
    'active': {
      Swatch: {
        background: color + ` url("data:image/svg+xml,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.08657 8.8765L0.298417 5.0965L1.739 3.65184L4.08453 5.99329L9.48569 0.592139L10.9283 2.03476L4.08657 8.8765Z' fill='%231B1C22'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.48567 0.3479L11.1725 2.03476L4.08669 9.12061L0.0541992 5.09681L1.7387 3.40754L4.08441 5.74916L9.48567 0.3479ZM9.48567 0.836387L4.08462 6.23744L1.73926 3.89616L0.542604 5.0962L4.08643 8.63239L10.684 2.03476L9.48567 0.836387Z' fill='%231B1C22'/%3E%3C/svg%3E") no-repeat center`,
        opacity: '100%'    
      }
    }
  }, { hover: hover, active: active });

  return React.createElement(
    'div',
    { style: styles.swatch },
    React.createElement(Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

export default handleHover(CircleSwatch);
